export const serviceUrl = 'https://sharemyventure.softmarvel.com/api/';
// export const serviceUrl = '/';
export const tokenName = 'token';
export const iName = 'iname';